<template>
  <div>
      <el-dialog
          :visible.sync="visible"
          :close-on-click-modal="false"
          @close="$emit('update:show', false)"
          :show="show"
          :append-to-body="true"
          title="用户注册服务条款和声明"
          width="700px">
          <div class="ruleBox">
            <p class="mar-bottom15 fontB">一、服务条款的确认和接纳</p>
            <p class="mar-bottom30">注册用户应当同意本协议的全部条款并按照页面上的提示完成全部的注册程序。用户在进行注册程序过程中点击"同意并继续"按钮即表示用户完全接受本协议项下的全部条款。</p>
            <p class="mar-bottom15 fontB">二、使用协议</p>
            <p class="mar-bottom15 fontB">（一）用户须知：</p>
            <p class="mar-bottom30 ">用户登录东莞市国际技术信息交互平台（以下简称本平台）需完善用户注册信息，当您阅读并同意本协议且按照注册页面提示完成全部注册程序后或在本协议更新时点击同意，即表示您已充分阅读、理解并接受本协议的全部内容。</p>
            <p class="mar-bottom15 fontB">（二）用户同意：</p>
            <p class="mar-bottom15">1、注册本平台账号后，通过使用相关功能、使用有关服务，本平台将根据您开启或使用的功能收集及使用您所提供的相关个人信息和用户信息。</p>
            <p class="mar-bottom15">2、在您浏览本平台的过程中，您可以选择对感兴趣的内容及/或服务进行收藏、建立关注关系、通过本平台提供的功能组件向其他第三方分享信息。在您使用上述功能的过程中，我们会收集包括您的收藏及关注关系、分享历史在内的服务日志信息用于实现上述功能及其他明确告知的目的。</p>
            <p class="mar-bottom15">3、用户同意遵守《中华人民共和国保守国家秘密法》、《中华人民共和国计算机信息系统安全保护条例》、《计算机软件保护条例》等有关计算机及互联网规定的法律和法规、实施办法。在任何情况下，本系统合理地认为用户的行为可能违反上述法律、法规，本系统可以在任何时候，不经事先通知终止向该用户提供服务。用户应了解国际互联网的无国界性，应特别注意遵守当地所有有关的法律和法规。</p>
            <p class="mar-bottom15">4、用户在使用该网服务过程中，必须遵循以下原则：</p>
            <p class="mar-bottom15">1、遵守中国有关的法律和法规；</p>
            <p class="mar-bottom15">2、不得为任何非法目的而使用服务系统；</p>
            <p class="mar-bottom15">3、遵守所有与服务有关的协议、规定和程序；</p>
            <p class="mar-bottom15">4、不得利用该网服务系统进行任何可能对互联网的正常运转造成不利影响的行为；</p>
            <p class="mar-bottom15">5、不得利用该网服务系统传输任何骚扰性的、中伤他人的、辱骂性的、恐吓性的、庸俗淫秽的或其他任何非法的信息资料；</p>
            <p class="mar-bottom15">6、不得利用该网服务系统进行任何不利于本系统的行为；</p>
            <p class="mar-bottom30">如发现任何非法使用用户帐号或帐号出现安全漏洞的情况，应立即通知本系统。</p>
            <p class="mar-bottom15 fontB">三、网站内容的所有权</p>
            <p class="mar-bottom30">本系统提供的服务内容可能包括：文字、软件、图片、图标等。所有这些内容受版权、商标和其它财产所有权法律的保护。</p>
            <p class="mar-bottom15 fontB">四、用户隐私制度</p>
            <p class="mar-bottom15">保护用户隐私是本系统的一项基本原则，本系统保证不对外公开或向第三方提供用户注册资料及其他非公开内容，但下列情况除外：</p>
            <p class="mar-bottom15">1、事先获得用户的明确授权；</p>
            <p class="mar-bottom15">2、根据有关的法律法规要求；</p>
            <p class="mar-bottom15">3、按照相关政府主管部门的要求；</p>
            <p class="mar-bottom15">4、为维护社会公众的利益；</p>
            <p class="mar-bottom15">5、为维护编码中心的合法权益。</p>
            <p class="mar-bottom15">本系统可能会与第三方合作用户提供相关服务，在此情况下，如该第三方同意承担与本系统同等的保护用户隐私的责任，则本系统可将用户的注册资料等提供给该第三方。</p>
            <p class="mar-bottom30">在不透露单个用户隐私资料的前提下，本系统有权对整个用户数据库进行分析并对用户数据库加以利用。</p>
            <p class="mar-bottom15 fontB">五、服务变更、中断或终止</p>
            <p class="mar-bottom15">如因系统维护或升级的需要而需暂停网络服务，本系统将尽可能事先进行通告。</p>
            <p class="mar-bottom15">如发生下列任何一种情形，本系统有权随时中断或终止向用户提供服务而无需通知用户：</p>
            <p class="mar-bottom15">1、用户提供的个人资料不真实；</p>
            <p class="mar-bottom15">2、用户违反本协议中规定的使用规则。</p>
            <p class="mar-bottom30">除前款所述情形外，本系统同时保留在不事先通知用户的情形下随时中断或终止部分或全部服务的权利，对于所有服务的中断或终止而造成的任何损失，本系统无需对用户或任何第三方承担任何责任。</p>
            <p class="mar-bottom15 fontB">六、有限责任</p>
            <p class="mar-bottom30">用户同意保障和维护本系统及其他用户的利益，如因用户违反有关法律、法规或本协议项下的任何条款而给本系统或任何其他第三方造成损失，用户同意承担由此造成的损害赔偿责任。</p>
            <p class="mar-bottom15 fontB">七、修改协议</p>
            <p class="mar-bottom15">本系统将可能不定时修改本协议的有关条款，一旦条款内容发生变动，本系统将会在相关的页面提示修改内容。</p>
            <p class="mar-bottom30">如果不同意本系统对服务条款所做的修改，用户有权停止一切服务。如果用户继续使用该网服务，则视为用户接受服务条款的变动。</p>
            <p class="mar-bottom15 fontB">八、用户责任</p>
            <p class="mar-bottom15">用户单独承担传输内容的责任。用户必须遵循：</p>
            <p class="mar-bottom15">1、不干扰或混乱网络服务。</p>
            <p class="mar-bottom15">2、不在论坛BBS或留言簿发表任何与政治相关的信息。</p>
            <p class="mar-bottom15">3、用户不得违反本协议中规定的使用规则。</p>
            <p class="mar-bottom15">4、不得利用本站危害国家安全、泄露国家秘密，不得侵犯国家社会集体的和公民的合法权益。</p>
            <p class="mar-bottom15">5、不得利用本站制作、复制和传播下列信息：</p>
            <p class="mar-bottom15">5.1.煽动抗拒、破坏宪法和法律、行政法规实施的；</p>
            <p class="mar-bottom15">5.2.煽动颠覆国家政权，推翻社会主义制度的；</p>
            <p class="mar-bottom15">5.3.煽动分裂国家、破坏国家统一的；</p>
            <p class="mar-bottom15">5.4.煽动民族仇恨、民族歧视，破坏民族团结的；</p>
            <p class="mar-bottom15">5.5.捏造或者歪曲事实，散布谣言，扰乱社会秩序的；</p>
            <p class="mar-bottom15">5.6.宣扬封建迷信、淫秽、色情、赌博、暴力、凶杀、恐怖、教唆犯罪的；</p>
            <p class="mar-bottom15">5.7.公然侮辱他人或者捏造事实诽谤他人的，或者进行其他恶意攻击的；</p>
            <p class="mar-bottom15">5.8.损害国家机关信誉的；</p>
            <p class="mar-bottom15">5.9.其他违反宪法和法律行政法规的。</p>
            <p class="mar-bottom30">用户须承诺不传输任何非法的、骚扰性的、中伤他人的、辱骂性的、恐吓性的、伤害性的、庸俗的和淫秽的信息资料。另外，用户也不能传输任何教唆他人构成犯罪行为的资料；不能传输国内不利条件和涉及国家安全的资料；不能传输任何不符合当地法规、国家法律和国际法律的资料。未经许可而非法进入其它电脑系统是禁止的。若用户的行为不符合以上的条款，本系统将取消用户服务帐号。</p>
            <p class="mar-bottom15 fontB">九、发送通告</p>
            <p class="mar-bottom30">本协议项下所有的通知均可通过重要页面公告、电子邮件或常规的信件传送等方式进行；该等通知于发送之日视为已送达收件人。</p>
            <p class="mar-bottom15 fontB">十、法律管辖</p>
            <p class="mar-bottom15">本协议的订立、执行和解释及争议的解决均应适用中国法律。</p>
            <p class="mar-bottom30">如双方就本协议内容或其执行发生任何争议，双方应尽量友好协商解决；协商不成时，任何一方均可向本系统所在地的人民法院提起诉讼。</p>
            <p class="mar-bottom15 fontB">十一、其他规定</p>
            <p class="mar-bottom15">本协议构成双方对本协议之约定事项及其他有关事宜的完整协议，除本协议规定的之外，未赋予本协议各方其他权利。</p>
            <p class="mar-bottom15">如本协议中的任何条款无论因何种原因完全或部分无效或不具有执行力，本协议的其余条款仍应有效并且有约束力。</p>
            <p class="mar-bottom30">本协议中的标题仅为方便而设，在解释本协议时应被忽略。</p>
            <p class="mar-bottom15 fontB">十二、免责声明</p>
            <p class="mar-bottom15">用户明确同意其使用该网服务所存在的风险将完全由其自己承担；因其使用该网服务而产生的一切后果也由其自己承担，本系统对用户不承担任何责任。</p>
            <p class="mar-bottom30">本系统不保证服务一定能满足用户的要求，也不保证服务不会中断，对服务的及时性、安全性、准确性也都不作保证。</p>
            <p class="mar-bottom15 fontB">十三、解释权</p>
            <p class="mar-bottom60">本协议的解释权归本系统所有。如果其中有任何条款与国家的有关法律相抵触，则以国家法律的明文规定为准。</p>
          </div>
      </el-dialog>
  </div>
</template>

<script>
export default {
  data () {
    return {
      visible: this.show,
    }
  },
  props: {
    show: {
        type: Boolean,
        default: false
    }
  },
  watch: {
    show () {
      this.visible = this.show;
    }
  },methods:{

  }
};
</script>

<style>
  @import '../../assets/font/iconfont.css';
  @import '../../assets/css/common-distance.css';
  @import '../../assets/css/common-default.css';
  @import '../../assets/css/common-color.css';
  @import '../../assets/css/topAndfoot.css';
  @import '../../assets/css/common-layout.css';
  @import '../../assets/css/layui.css';
  @import '../../assets/css/client.css';

  .ruleBox{height:470px;overflow-y:auto;}
</style>
